import { Typography } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import ContainerModal from './modal-container';

type PasswordRecoveryModalProps = {
  open: boolean;
  email: string;
  isSending: boolean;
  onClose: () => void;
  onSend: () => void;
};

const PasswordRecoveryModal: FC<PasswordRecoveryModalProps> = ({
  open,
  email,
  isSending,
  onClose,
  onSend,
}) => {
  const { t } = useTranslation();

  return (
    <ContainerModal
      open={open}
      onClose={onClose}
      onCancel={onClose}
      onSave={onSend}
      loadingSaveButton={isSending}
      modalTitle={t('users:password-recovery-title')}
      submitText={t('users:password-recovery-send')}
      submitIcon="paper-plane"
      maxWidth="sm"
    >
      <Typography variant="body2">
        {t('users:password-recovery-description', { email })}
      </Typography>
    </ContainerModal>
  );
};

export default PasswordRecoveryModal;
